<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-account">
        <ul class="mc-account__menu mc-account-menu">

          <li class="mc-account-menu__item">
            <router-link to="/loyalty/"  class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Программа лояльности
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/page/oferta/"  class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Оферта
                                </span>
            </router-link>
          </li>
          <li class="mc-account-menu__item">
            <router-link to="/page/cookie/"  class="mc-account-menu__link">
                                <span class="mc-account-menu__link-title">
                                    Политика конфиденциальности
                                </span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  components: {

  },
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  created() {

  },
  computed: {

  },
  async mounted() {

  },
  methods: {

  },
  data: () => ({
    error: [],
    sending: false,
    error_text: [],
  phone: '',
    code: '',
    step: 1
  }),
}
</script>
